import React from "react";
import {
    Routes,
    Route
} from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Clients from "./components/Clients/Clients";
import About from "./components/About/About";
import Stats from "./components/Stats/Stats";
import Tabs from "./components/Tabs/Tabs";
import Portfolio from "./components/Portfolio/Portfolio";
import Testimonials from "./components/Testimonials/Testimonials";
import Faq from "./components/Faq/Faq";
import Team from "./components/Team/Team";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import AboutPage from "./pages/Aboutpage/AboutPage";
import PodcastPage from "./pages/PodcastPage/PodcastPage";
import WebinarPage from "./pages/WebinarPage/WebinarPage";
import EventPage from "./pages/EventPage/EventPage";
import CoursesPage from "./pages/CoursesPage/CoursesPage";
import GalleryPage from "./pages/GalleryPage/GalleryPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import ScrollToTop from "./components/ScrollToTop";
import TeamPage from "./pages/TeamPage/TeamPage";
import BookNow from "./pages/BookNow/BookNow";
import {
    AuthProvider
} from "./components/AuthContext";
import PrivateRoute from "./components/Route/PrivateRoute";

function App() {
    return ( <
        AuthProvider >
        <
        ScrollToTop / >
        <
        Navbar / > {
            /* ✅ Always visible and will react to auth state */
        }

        <
        Routes > {
            /* Public Routes */
        } <
        Route path = "/login"
        element = {
            <
            LoginPage / >
        }
        /> <
        Route path = "/profile"
        element = {
            <
            PrivateRoute >
            <
            ProfilePage / >
            <
            /PrivateRoute>
        }
        />

        <
        Route path = "/"
        element = {
            <
            >
            <
            main className = "main" >
            <
            Hero / >
            <
            Clients / >
            <
            About / >
            <
            Stats / >
            <
            Tabs / >
            <
            Portfolio / >
            <
            Testimonials / >
            <
            Faq / >
            <
            Team / >
            <
            Contact / >
            <
            /main> <
            Footer / >
            <
            />
        }
        />

        <
        Route path = "/about-details"
        element = {
            <
            AboutPage / >
        }
        /> <
        Route path = "/podcast"
        element = {
            <
            PodcastPage / >
        }
        /> <
        Route path = "/webinar"
        element = {
            <
            WebinarPage / >
        }
        /> <
        Route path = "/events"
        element = {
            <
            EventPage / >
        }
        /> <
        Route path = "/courses"
        element = {
            <
            CoursesPage / >
        }
        /> <
        Route path = "/gallery"
        element = {
            <
            GalleryPage / >
        }
        /> <
        Route path = "/team"
        element = {
            <
            Team / >
        }
        /> <
        Route path = "/team/:id"
        element = {
            <
            TeamPage / >
        }
        /> <
        Route path = "/book-now"
        element = {
            <
            BookNow / >
        }
        /> < /
        Routes > <
        /AuthProvider>
    );
}

export default App;